// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".boxInfo[data-v-f2d71a68] {\n  height: 100%;\n}\n.boxInfo .addFormBox[data-v-f2d71a68] {\n  height: calc(100vh - 125px);\n  padding: 15px;\n  overflow-y: auto;\n}\n.boxInfo .addFooter[data-v-f2d71a68] {\n  border-top: 1px solid #ccc;\n  padding: 10px;\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
